document.addEventListener('click', event => {
  const element = event.target

  if (element.dataset.behavior && element.dataset.behavior.includes('calculate-home-affordability')) {
    const monthlyIncome = parseFloat(document.querySelector('[name="monthly-income"]').value.replace(/[$,]+/g, ''))
    const monthlyDebt = parseFloat(document.querySelector('[name="monthly-debt"]').value.replace(/[$,]+/g, ''))
    const interestRate = parseFloat(document.querySelector('[name="interest-rate"]').value)
    const loanLength = parseFloat(document.querySelector('[name="loan-length"]').value)

    const piti = window.Calculator.getPitiByIncome(monthlyIncome, monthlyDebt)
    const affordableLoanAmount = window.Calculator.getLoanAmount(piti, loanLength, interestRate)

    if (element.closest('form').checkValidity()) {
      document.querySelector('[data-calculate="affordable-loan-amount"]').value = '$' + (affordableLoanAmount || 0).formatFloat()
    }
  }
}, false)
